import { Box, Button, Grid, makeStyles, TextField } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";
import { Controller, useFieldArray } from "react-hook-form";
import NestedLogoSection from "../NestedLogoSection";
import { id } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  footerColumnBlk: {
    background: "#FFFFFF",
    width: "100%",
    marginBottom: "20px",
  },
  footerColumnBlkHeader: {
    background: "#EDEEF0",
    borderLeft: "3px solid #306F9D",
    color: "#306F9D",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    padding: "12px 13px",
  },
  footerColumnBlkBody: {
    border: "1px solid #CCCCCC",
    borderTop: "0px",
    padding: "20px 13px",
    width: "100%",
  },
  deleteBtn: {
    margin: "0",
    padding: "0",
    minWidth: "initial",
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
    },
  },
}));

const defaultValue = {
  localizations: {
    en: {"title": ""},
    tc: {"title": ""},
  },
  items: [],
};

function FooterColumnSections(props) {
  const { control, setValue, activeLang, getValues, disabled } = props;
  const classes = useStyles();
  const { fields, append, remove } = useFieldArray(
    {
      control,
      name: "footerColumns",
      keyName: "_id",
    }
  );

  // make sure title update when activeLang change
  React.useEffect(() => {
    // Ensure fields are not undefined or empty
    if (fields && fields.length > 0 && fields[0].localizations) {
      fields.forEach((field, index) => {
        // Ensure the localizations object is defined before accessing its properties
        const newTitle = field.localizations?.[activeLang]?.title || '';
        setValue(`footerColumns.${index}.localizations.${activeLang}.title`, newTitle);
      });
    }
  }, [activeLang, fields, setValue]);

  const removeColumn = (index) => {
    const newFields = fields.filter((field, i) => i !== index);
    setValue("footerColumns", newFields);
    console.log("Remove Column:", index);
  }

  return (
    <>
      {fields.map((data, index) => (
        <div className={classes.footerColumnBlk} key={data._id}>
          <Grid container>
            <Grid
              container
              item
              className={classes.footerColumnBlkHeader}
              xs={12}
              alignItems="center"
              justify="space-between"
            >
              <span>Column {index + 1}</span>
              {disabled || (
                <Button
                  className={classes.deleteBtn}
                  onClick={() => removeColumn(index)}
                >
                  <Close style={{ fontSize: "14px", lineHeight: "16px" }} />
                </Button>
              )}
            </Grid>
            <Grid
              container
              style={activeLang === "tc" ? { display: "none" } : {}}
            >
              <Box className={classes.footerColumnBlkBody}>
                <Controller
                  control={control}
                  defaultValue={data.localizations.en?.title}
                  name={`footerColumns.${index}.localizations.en.title`}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="outlined"
                      margin="dense"
                      label="Column Title"
                      className={classes.textInput}
                      fullWidth
                      {...field}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
                <NestedLogoSection
                  nestedIndex={index}
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  data={data.items}
                  activeLang="en"
                  disabled={disabled}
                />
              </Box>
            </Grid>
            <Grid
              container
              style={activeLang === "en" ? { display: "none" } : {}}
            >
              <Box className={classes.footerColumnBlkBody}>
                <Controller
                  control={control}
                  defaultValue={data.localizations.tc?.title}
                  name={`footerColumns.${index}.localizations.tc.title`}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      variant="outlined"
                      margin="dense"
                      label="Column Title"
                      className={classes.textInput}
                      fullWidth
                      {...field}
                      error={!!error}
                      helperText={error ? error.message : ""}
                    />
                  )}
                />
                <NestedLogoSection
                  nestedIndex={index}
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  data={data.items}
                  activeLang="tc"
                  disabled={disabled}
                />
              </Box>
            </Grid>
          </Grid>
        </div>
      ))}
      <Grid container xs={12} justify="flex-end">
        {disabled || (
          <Button
            onClick={() => append(defaultValue)}
            variant="contained"
            color="primary"
          >
            Add New Column
          </Button>
        )}
      </Grid>
    </>
  );
}

export default FooterColumnSections;
